export default "__VITE_ASSET__ChZrowyj__"